import api from './api';

export interface GoogleContactSuggestion {
  name: string;
  email: string;
  photoUrl?: string;
}

export async function searchGoogleContacts(query: string): Promise<GoogleContactSuggestion[]> {
  if (!query || query.trim().length === 0) return [];
  const resp = await api.get('/contacts/google/search', { params: { q: query } });
  return resp.data?.data || [];
}


